import Homework from '../homework';

/**
 * Create the action
 */

const { thunk, request, success, error } = Homework.store((data, fetch) => {

    if (data.moveHomeworkAfterScheduleChange === true) {
        return fetch.post('homework-move', data);
    }

    // Prepare request
    let formData = new FormData();

    const fields = Object.keys(data);
 
    fields.map((field) => {
        if (field == 'mark') {
            return formData.append(field, data[field] ? 1 : 0);
        }

        formData.append(field, data[field]);
    });

    return fetch.post('homework', formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };